import React from 'react';
import { withTranslation } from 'react-i18next';
import { Modal, Button, Input, message, Tag, Tooltip } from 'antd';
import { Container, InputContainer, ModalTagContainer } from './styles';
import {
  addTemplateTags,
  addElementTags,
  addMailTemplateTags,
  addMailElementTags,
  addShortMessageTags,
} from '../../utils/services/tagAPI';
import { MANAGE_TEMPLATE_TAGS_MODAL } from './translationValues';
import { AppStoreContext } from '../../context/appStoreContext';
import { updateTags } from '../../utils/services/complexDocumentsAPI';

const NAMESPACES = ['MANAGE_TEMPLATE_TAGS_MODAL'];
class AddTagsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      inputVisible: true,
      inputValue: '',
      editInputIndex: -1,
      editInputValue: '',
      isLoading: true,
      borderVisibility: false,
      isvalidTag: true,
    };
  }

  static contextType = AppStoreContext;

  handleClose = removedTag => {
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    this.setState({ tags });
  };

  handleInputChange = e => {
    let { tags } = this.state;
    let tagTestStatus;
    let trimedTag = e.target.value.trim();
    let exists = tags.some(tag => tag.toLowerCase() === trimedTag.toLowerCase());
    if (exists) {
      tagTestStatus = false;
    } else {
      tagTestStatus = true;
    }
    this.setState({
      inputValue: e.target.value,
      borderVisibility: true,
      isvalidTag: tagTestStatus,
    });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    const { t } = this.props;
    let { tags } = this.state;
    let trimedTag = inputValue.trim();
    if (trimedTag.length > 0) {
      let exists = tags.some(tag => tag.toLowerCase() === trimedTag.toLowerCase());
      if (!exists) {
        tags.push(trimedTag);
      } else {
        message.error(t(MANAGE_TEMPLATE_TAGS_MODAL.TAGS_ALREADY_EXIST_ERROR_MESSAGE.key, MANAGE_TEMPLATE_TAGS_MODAL.TAGS_ALREADY_EXIST_ERROR_MESSAGE.value));
      }
    }
    this.setState({
      tags,
      inputValue: '',
    });
  };

  saveInputRef = input => {
    this.input = input;
  };

  componentDidMount() {
    const { target } = this.props;
        let tagArray;
    if (target && target.tags) {
      tagArray = target.tags.split(',');
    } else {
      tagArray = [];
    }
    this.setState({
      isLoading: false,
      tags: tagArray,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { tags } = this.state;
    if (prevState.tags !== tags) {
      this.setState({
        isvalidTag: true,
      });
    }   
  }
  
  addTags = async () => {
    const { isvalidTag } = this.state;
    const { target, onCancel, t, isEmail, isShortMessage, isElement, isComplex, isFlow ,onSuccess } = this.props;
    const { updateCategoryTemplates, updateCategoryElements, updateEditorTemplate } = this.context;   
    this.setState({
      isLoading: true,   
    });
     let response;
    let payload = {
      id: isEmail && !isElement ? target?.mailTemplateId : target?.id,
      tags: this.state.tags,
      elementType: target.elementType,
    };
    if(isComplex) {
      payload.id = target?.id
      payload.tags = this.state.tags.join(',');
      payload.type =  payload.elementType;
    }
    let emailPayload;
    if (isEmail && isElement) {
      emailPayload = target;
      emailPayload.tags = this.state.tags.join();
    }
    if(isFlow){
      payload.tags = this.state.tags.join(',');
      payload.type = target.elementType;
      payload.id = target?.id
    }
    if (isvalidTag) {
      if (!isEmail) {
        if (!isElement) {
          if (!isShortMessage) {
            response = isComplex || isFlow  ? await updateTags(payload) : await addTemplateTags(payload);
          } else {
            response = await addShortMessageTags(payload);
          }
        } else {
          response = await addElementTags(payload);
        }
      } else {
        if (!isElement) {
          response = await addMailTemplateTags(payload);
        } else {
          response = await addMailElementTags(target, emailPayload);
        }
      }
    } else {
      message.error(t(MANAGE_TEMPLATE_TAGS_MODAL.TAGS_ALREADY_EXIST_ERROR_MESSAGE.key, MANAGE_TEMPLATE_TAGS_MODAL.TAGS_ALREADY_EXIST_ERROR_MESSAGE.value));
      this.setState({
        isvalidTag: true,
      });
    }
    // Response handling
    if (response && response.errors && response.errors.length === 0) {
      if (!isElement) {
        let updatedTemplate = target;
        updatedTemplate.tags = payload.tags.toString();
        updateCategoryTemplates(updatedTemplate, 'updateTemplateTags');
        updateEditorTemplate(updatedTemplate, 'updateTemplateTags');
      } else {
        let updatedElement = target;
        updatedElement.tags = payload.tags.toString();
        updateCategoryElements(updatedElement, 'updateCategoryElementTag');
      }
      message.success(isShortMessage ? t(MANAGE_TEMPLATE_TAGS_MODAL.TAGS_LIST_UPDATED_SUCCESSFULL_MESSAGE.key, MANAGE_TEMPLATE_TAGS_MODAL.TAGS_LIST_UPDATED_SUCCESSFULL_MESSAGE.value) : t(MANAGE_TEMPLATE_TAGS_MODAL.TAGS_UPDATED_SUCCESSFULL_MESSAGE.key, MANAGE_TEMPLATE_TAGS_MODAL.TAGS_UPDATED_SUCCESSFULL_MESSAGE.value));
      onCancel(true);
    }
    this.setState({
      isLoading: false,
    });

    if (onSuccess) {
      onSuccess(this.state.tags)
    }
   
  };

  handleInputFocus = () => {
    this.setState({
      borderVisibility: true,
    });
  };

  handleInputOutofFocus = () => {
    this.handleInputConfirm();
    this.setState({
      borderVisibility: false,
    });
  };

  render() {
    const { t, visible, onCancel } = this.props;
    const { tags, inputValue, borderVisibility, isLoading } = this.state;
    return (
      <Container onKeyDown={e => e.stopPropagation()}>
        {!isLoading && (
          <Modal
            title={t(MANAGE_TEMPLATE_TAGS_MODAL.MANAGE_TAGS_TITLE.key, MANAGE_TEMPLATE_TAGS_MODAL.MANAGE_TAGS_TITLE.value)}
            width="600px"
            centered
            visible={visible}
            onCancel={() => onCancel(false)}
            footer={[
              <Button key="back" onClick={() => onCancel(false)}>
                {t(MANAGE_TEMPLATE_TAGS_MODAL.CANCEL_ADDING_NEW_TAGS_BUTTON.key, MANAGE_TEMPLATE_TAGS_MODAL.CANCEL_ADDING_NEW_TAGS_BUTTON.value)}
              </Button>,
              <Button key="Add Tags" type="primary" loading={isLoading} onClick={this.addTags}>
              {isLoading
                ? t(MANAGE_TEMPLATE_TAGS_MODAL.SAVING_BUTTON.key, MANAGE_TEMPLATE_TAGS_MODAL.SAVING_BUTTON.value)
                : t(MANAGE_TEMPLATE_TAGS_MODAL.SAVE_TAGS_BUTTON.key, MANAGE_TEMPLATE_TAGS_MODAL.SAVE_TAGS_BUTTON.value)}
            </Button>,
            ]}
          >
            <ModalTagContainer border={borderVisibility}>
              {tags.map((tag, index) => {
                const isLongTag = tag.length > 20;
                const tagElem = (
                  <Tag
                    className="edit-tag"
                    key={tag}
                    closable={true}
                    onClose={() => this.handleClose(tag)}
                    color="#df4c35"
                  >
                    <span>{isLongTag ? `${tag.slice(0, 20)}...` : tag}</span>
                  </Tag>
                );
                return isLongTag ? (
                  <Tooltip title={tag} key={tag}>
                    {tagElem}
                  </Tooltip>
                ) : (
                  tagElem
                );
              })}
              <InputContainer tagInput>
                <Input
                  name="tagName"
                  ref={this.saveInputRef}
                  type="text"
                  className="tag-input"
                  value={inputValue}
                  onFocus={this.handleInputFocus}
                  onChange={this.handleInputChange}
                  onBlur={this.handleInputOutofFocus}
                  onPressEnter={this.handleInputConfirm}
                  placeholder= {t(MANAGE_TEMPLATE_TAGS_MODAL.ADD_TAGS_PLACEHOLDER.key, MANAGE_TEMPLATE_TAGS_MODAL.ADD_TAGS_PLACEHOLDER.value)}
                  autoComplete={"off"}
                />
              </InputContainer>
            </ModalTagContainer>
          </Modal>
        )}
      </Container>
    );
  }
}

export default withTranslation(NAMESPACES)(AddTagsModal);
